import { VehicleStatusEnum } from '@/services/api-clients';

export function vehicleStatusColorFilter(status: VehicleStatusEnum) {
  switch (status) {
    case VehicleStatusEnum.Available: return 'green';
    case VehicleStatusEnum.Busy: return 'red';
    case VehicleStatusEnum.InWorkshop: return 'indigo darken-4';
    case VehicleStatusEnum.ReceivingFromWorkshop: return 'indigo lighten-1';
    case VehicleStatusEnum.Theft: return 'red';
    default: return '';
  }
}
